import { createRoute } from '@tanstack/react-router';

import { projectPageLoadable } from 'pages/project-page';

import { AuthenticatedRoute } from '../authenticated-route';

export const ProjectRoute = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: '/installations/$orgName/$repoName',
  component: projectPageLoadable,
});
